/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// Max range info popup
document.addEventListener('DOMContentLoaded', function() {
  const infoButtons = document.querySelectorAll('.product-form__option-name--info');
  
  infoButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.stopPropagation();
      
      let infoContent = this.nextElementSibling;
      if (!infoContent || !infoContent.classList.contains('product-form__option-name--info-content')) {
        infoContent = this.parentElement.querySelector('.product-form__option-name--info-content');
      }
      
      if (infoContent) {
        infoContent.style.display = 'block';
      }
    });
  });
  
  const closeButtons = document.querySelectorAll('.product-form__option-name--info-content--close');
  closeButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.stopPropagation();
      const infoContent = this.closest('.product-form__option-name--info-content');
      if (infoContent) {
        infoContent.style.display = 'none';
      }
    });
  });
  
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.product-form__option-name--info-content') && 
        !e.target.closest('.product-form__option-name--info')) {
      const infoContents = document.querySelectorAll('.product-form__option-name--info-content');
      infoContents.forEach(content => {
        content.style.display = 'none';
      });
    }
  });
  
  // Product gallery variant switcher
  function initializeProductGalleryVariants() {
    const galleryItems = document.querySelectorAll('gallery-item');
    
    galleryItems.forEach(item => {
      // Skip if already initialized
      if (item.dataset.variantListenersAttached === 'true') return;
      item.dataset.variantListenersAttached = 'true';
      
      const variantInputs = item.querySelectorAll('.variant-option-input');
      const variantsDataDiv = item.querySelector('[data-variants-data]');
      const priceContainer = item.querySelector('.products_gallery--item-price');
      const metafieldsContainer = item.querySelector('.variant-metafields');
      const detailedSpecsContainer = item.querySelector('.detailed-specs');
      const variantAccordion = item.querySelector('.variant-accordion');
      
      if (!variantsDataDiv) return;
      
      const variantsData = JSON.parse(variantsDataDiv.dataset.variantsData || '{}');
      const productId = variantsDataDiv.dataset.productId;
      
      function findVariantByOptions(selectedOptions) {
        for (const [variantId, variantData] of Object.entries(variantsData)) {
          if (JSON.stringify(variantData.options) === JSON.stringify(selectedOptions)) {
            return { id: variantId, ...variantData };
          }
        }
        return null;
      }
      
      function updatePriceDisplay(variant) {
      if (!priceContainer || !variant) return;
      
      const priceStr = variant.price;
      const compareAtPriceStr = variant.compare_at_price;
      
      let priceSpan = priceContainer.querySelector('.price:not(.price--compare)');
      let compareSpan = priceContainer.querySelector('.price--compare');
      
      if (compareAtPriceStr && compareAtPriceStr.trim() !== '') {
        const priceNum = parseFloat(priceStr.replace(/[^\d.,]/g, '').replace(/,/g, ''));
        const compareNum = parseFloat(compareAtPriceStr.replace(/[^\d.,]/g, '').replace(/,/g, ''));
        
        if (compareNum > priceNum) {
          if (!priceSpan || !priceSpan.classList.contains('price--sale')) {
            priceContainer.innerHTML = `
              <span class="price price--sale">${priceStr}</span>
              <span class="price price--compare">${compareAtPriceStr}</span>
            `;
          } else {
            priceSpan.textContent = priceStr;
            compareSpan.textContent = compareAtPriceStr;
          }
        } else {
          if (!priceSpan || priceContainer.querySelectorAll('.price').length > 1) {
            priceContainer.innerHTML = `<span class="price">${priceStr}</span>`;
          } else {
            priceSpan.textContent = priceStr;
          }
        }
      } else {
        if (!priceSpan || priceContainer.querySelectorAll('.price').length > 1) {
          priceContainer.innerHTML = `<span class="price">${priceStr}</span>`;
        } else {
          priceSpan.textContent = priceStr;
        }
      }
      }
      
      function updateMetafields(variant) {
        if (!metafieldsContainer || !variant) return;
        
        const metafields = ['steigfahigkeit', 'max_zuladung', 'peakleistung', 'gewicht'];
        metafields.forEach(field => {
          const metafieldItem = metafieldsContainer.querySelector(`[data-metafield="${field}"]`);
          if (metafieldItem) {
            const valueSpan = metafieldItem.querySelector('.metafield-value');
            if (variant[field]) {
              metafieldItem.style.display = '';
              if (valueSpan) {
                valueSpan.textContent = variant[field];
              }
            } else {
              metafieldItem.style.display = 'none';
            }
          }
        });
      }
      
      function updateDetailedSpecs(variant) {
        if (!detailedSpecsContainer || !variant) return;
        
        const specs = ['wattstunden_akku', 'ladezeit', 'federung_vorne', 'federung_hinten', 
                       'bremssystem_vorne', 'bremssystem_hinten', 'blinker', 'ip_schutzgrad'];
        specs.forEach(field => {
          const specItem = detailedSpecsContainer.querySelector(`[data-metafield="${field}"]`);
          if (specItem) {
            const valueSpan = specItem.querySelector('.spec-value');
            if (variant[field]) {
              specItem.style.display = '';
              if (valueSpan) {
                valueSpan.textContent = variant[field];
              }
            } else {
              specItem.style.display = 'none';
            }
          }
        });
      }
      
      function updateVariantDescription(variant) {
        if (!variantAccordion || !variant) return;
        
        const valueSpan = variantAccordion.querySelector('.metafield-value');
        if (variant.varianten_beschreibung) {
          variantAccordion.style.display = '';
          if (valueSpan) {
            valueSpan.textContent = variant.varianten_beschreibung;
          }
        } else {
          variantAccordion.style.display = 'none';
        }
      }
      
      function updateDeliveryLabel(variant) {
        let availableLabel = item.querySelector('.product_gallery--item-available');
        let outOfStockLabel = item.querySelector('.product_gallery--item-out-of-stock');
        const comingSoonLabel = item.querySelector('.product_gallery--item-coming-soon');
        const quickViewBtns = item.querySelectorAll('.product-gallery-quick-view-btn');
        
        if (!variant) return;
        
        // Use Shopify's translated strings instead of hardcoded German text
        var translations = {
          quickViewButton: window.themeVariables?.strings?.productFormAddToCart || 'Quick ansehen',
          outOfStockButton: window.themeVariables?.strings?.productFormSoldOut || 'Ausverkauft',
          outOfStock: window.themeVariables?.strings?.productFormUnavailable || 'Aktuell nicht lieferbar',
          preorderDefault: window.themeVariables?.strings?.productFormPreOrder || 'Lieferbar Ende November',
          addToCart: window.themeVariables?.strings?.productFormAddToCart || 'In den Warenkorb'
        };
        
        // Update quick view button text based on availability
        quickViewBtns.forEach(function(btn) {
          var btnText = btn.querySelector('.btn-text');
          if (btnText) {
           var currentAvailable = btn.getAttribute('data-available');
            var newAvailable = variant.available ? 'true' : 'false';

            // Only update if availability state changed
            if (currentAvailable !== newAvailable) {
              if (variant.available) {
                btnText.textContent = translations.addToCart;
                btn.setAttribute('data-available', 'true');
              } else {
                btnText.textContent = translations.outOfStockButton;
                btn.setAttribute('data-available', 'false');
              }
              // Trigger Weglot to translate the German text we just set
              if (window.Weglot) {
                Weglot.translate();
              }
            }
          }
        });
        
        // Check if product is preorder (from data attribute) or variant has incoming date
        const productInfo = item.querySelector('.products_gallery--item-info');
        const isProductPreorder = productInfo && productInfo.dataset.isPreorder === 'true';
        const hasIncomingDate = variant.incoming_date_single && variant.incoming_date_single.trim() !== '';
        const isPreorder = isProductPreorder || hasIncomingDate;
        
        // Create available label if it doesn't exist (needed when initial variant was preorder)
        if (!availableLabel && (outOfStockLabel || comingSoonLabel)) {
          var availableIconUrl = '';
          // Try to find the icon from any available label on the page (including other products)
          var existingAvailableImg = document.querySelector('.product_gallery--item-available img');
          if (existingAvailableImg) {
            availableIconUrl = existingAvailableImg.src;
          } else {
            // Try to find out of stock icon and replace with available
            var existingOutOfStockImg = document.querySelector('.product_gallery--item-out-of-stock img');
            if (existingOutOfStockImg) {
              availableIconUrl = existingOutOfStockImg.src.replace('Soldout.svg', 'Available.svg');
            }
          }
          
          availableLabel = document.createElement('div');
          availableLabel.className = 'product_gallery--item-available';
          availableLabel.style.display = 'none';
          if (availableIconUrl) {
            availableLabel.innerHTML = '<img src="' + availableIconUrl + '" style="width: 45px; height: auto;"><span class="dynamic-delivery-date available-value"></span>';
          } else {
            availableLabel.innerHTML = '<span class="dynamic-delivery-date available-value"></span>';
          }
          
          // Insert before coming soon label if it exists, otherwise before out of stock label
          var referenceNode = comingSoonLabel || outOfStockLabel;
          if (referenceNode && referenceNode.parentNode) {
            referenceNode.parentNode.insertBefore(availableLabel, referenceNode);
          }
        }
        
        // Create out of stock label if it doesn't exist (only needed if initial variant was in stock)
        if (!outOfStockLabel && (availableLabel || comingSoonLabel)) {
          var iconUrl = '';
          var existingAvailableImg = document.querySelector('.product_gallery--item-available img');
          if (existingAvailableImg) {
            iconUrl = existingAvailableImg.src.replace('Available.svg', 'Soldout.svg');
          }
          
          outOfStockLabel = document.createElement('div');
          outOfStockLabel.className = 'product_gallery--item-out-of-stock';
          outOfStockLabel.style.display = 'none';
          if (iconUrl) {
            outOfStockLabel.innerHTML = '<img src="' + iconUrl + '" style="width: 45px; height: auto; margin-right: 5px; vertical-align: middle;"><span class="out-of-stock-value">Aktuell nicht lieferbar</span>';
          } else {
            outOfStockLabel.innerHTML = '<span class="out-of-stock-value">Aktuell nicht lieferbar</span>';
          }
              // Insert before coming soon label if it exists, otherwise before available label
          var referenceNode = comingSoonLabel || availableLabel;
          if (referenceNode && referenceNode.parentNode) {
            referenceNode.parentNode.insertBefore(outOfStockLabel, referenceNode);
          }
        }
        
        // Show/hide labels based on availability
        if (variant.available && !hasIncomingDate) {
          // In stock and not preorder - show delivery label
          if (availableLabel && availableLabel.style.display !== 'flex') {
            availableLabel.style.display = 'flex';
          }
          if (outOfStockLabel && outOfStockLabel.style.display !== 'none') {
            outOfStockLabel.style.display = 'none';
          }
          if (comingSoonLabel && comingSoonLabel.style.display !== 'none') {
            comingSoonLabel.style.display = 'none';
          }
        } else if (!variant.available && !hasIncomingDate) {
          // Out of stock and not preorder - show out of stock label
          if (availableLabel && availableLabel.style.display !== 'none') {
            availableLabel.style.display = 'none';
          }
          if (outOfStockLabel && outOfStockLabel.style.display !== 'flex') {
            outOfStockLabel.style.display = 'flex';
          }
          if (comingSoonLabel && comingSoonLabel.style.display !== 'none') {
            comingSoonLabel.style.display = 'none';
          }
        } else if (isPreorder) {
          // Preorder - show coming soon label with variant-specific text
          if (availableLabel && availableLabel.style.display !== 'none') {
            availableLabel.style.display = 'none';
          }
          if (outOfStockLabel && outOfStockLabel.style.display !== 'none') {
            outOfStockLabel.style.display = 'none';
          }
          if (comingSoonLabel) {
            var comingSoonValue = comingSoonLabel.querySelector('.coming-soon-value');
            var currentValue = comingSoonValue ? comingSoonValue.textContent.trim() : '';
            var newValue = variant.incoming_date_single || translations.preorderDefault;

            // Only update if the coming soon date actually changed
            if (comingSoonLabel.style.display !== 'block' || currentValue !== newValue) {
              comingSoonLabel.style.display = 'block';
              if (comingSoonValue) {
                comingSoonValue.textContent = newValue;
              }
            } else {
              // Already showing same value - don't update (preserve translation)
              comingSoonLabel.style.display = 'block';
            }
          }
        } else {
          // Hide all
          if (availableLabel) availableLabel.style.display = 'none';
          if (outOfStockLabel) outOfStockLabel.style.display = 'none';
          if (comingSoonLabel) comingSoonLabel.style.display = 'none';
        }
      }
      
      
      variantInputs.forEach(input => {
        input.addEventListener('change', function(e) {
          if (e.target.dataset.handledBySection) return;
          
          const selectedOptions = [];
          const checkedInputs = item.querySelectorAll('.variant-option-input:checked');
          checkedInputs.forEach(checked => {
            selectedOptions.push(checked.dataset.optionValue);
          });
          
          const variant = findVariantByOptions(selectedOptions);
          
          if (variant) {
            updatePriceDisplay(variant);
            updateMetafields(variant);
            updateDetailedSpecs(variant);
            updateVariantDescription(variant);
            updateDeliveryLabel(variant);
          }
        });
      });
    });
  }
  
  // Initialize on page load
  initializeProductGalleryVariants();
  
  // Reinitialize after filtering (when products are replaced via AJAX)
  const facetMain = document.querySelector('#facet-main');
  if (facetMain) {
    const facetObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          // Products were replaced, reinitialize variant listeners
          initializeProductGalleryVariants();
        }
      });
    });
    
    facetObserver.observe(facetMain, {
      childList: true,
      subtree: false
    });
  }
});

// Cookie Management - Open cookie popup when clicking #manage-cookies link
document.addEventListener('DOMContentLoaded', function() {
  console.log('Cookie management script loaded');

  document.addEventListener('click', function(event) {
    console.log('Click detected on:', event.target);

    const clickedLink = event.target.closest('a');

    if (clickedLink) {
      const href = clickedLink.getAttribute('href') || '';
      console.log('Link clicked with href:', href);

      // Check if link ends with #manage-cookies (handles language URLs too)
      if (href.endsWith('#manage-cookies')) {
        console.log('Manage cookies link detected!');
        event.preventDefault();

        // First, load the Customer Privacy API
        console.log('Loading Shopify Customer Privacy API...');
        window.Shopify.loadFeatures([{
          name: "consent-tracking-api",
          version: "0.1"
        }], (error) => {
          if (error) {
            console.error('Failed to load Customer Privacy API:', error);
            alert('Cookie management system could not be loaded. Please try again.');
            return;
          }

          console.log('Customer Privacy API loaded successfully');

          // Method 1: Try using privacyBanner.showPreferences() (recommended by Shopify docs)
          if (typeof window.privacyBanner !== 'undefined' && window.privacyBanner.showPreferences) {
            console.log('Using privacyBanner.showPreferences() method...');

            window.privacyBanner.showPreferences().then(() => {
              console.log('Privacy preferences modal opened successfully');
            }).catch((err) => {
              console.log('privacyBanner.showPreferences() failed:', err);
              tryAlternativeMethods();
            });
          } else {
            console.log('privacyBanner.showPreferences() not available, trying alternatives...');
            tryAlternativeMethods();
          }

          function tryAlternativeMethods() {
            // Method 2: Try opening existing cookie-bar element
            const cookieBar = document.querySelector('cookie-bar');
            console.log('Cookie bar element found:', cookieBar);

            if (cookieBar) {
              console.log('Opening cookie bar element...');
              cookieBar.open = true;

              // Scroll to the cookie bar
              setTimeout(() => {
                cookieBar.scrollIntoView({ 
                  behavior: 'smooth', 
                  block: 'nearest' 
                });
                console.log('Scrolled to cookie bar');
              }, 100);
            } else {
              // Method 3: Check if we should show a banner and force it
              if (window.Shopify.customerPrivacy.shouldShowBanner && window.Shopify.customerPrivacy.shouldShowBanner()) {
                console.log('Shopify says banner should be shown, but no cookie bar found');
                console.log('This might indicate a theme configuration issue');

                // Show current consent status for debugging
                console.log('Current visitor consent:', window.Shopify.customerPrivacy.currentVisitorConsent());
                console.log('Current region:', window.Shopify.customerPrivacy.getRegion());

                alert('Cookie preferences are available but the interface could not be loaded. Please enable the privacy bar in theme settings.');
              } else {
                console.log('Shopify determined no banner should be shown');
                console.log('Current visitor consent:', window.Shopify.customerPrivacy.currentVisitorConsent());
                console.log('Current region:', window.Shopify.customerPrivacy.getRegion());

                // Show a custom consent management interface
                showCustomConsentInterface();
              }
            }
          }

          function showCustomConsentInterface() {
            console.log('Showing custom consent interface...');

            const currentConsent = window.Shopify.customerPrivacy.currentVisitorConsent();
            const region = window.Shopify.customerPrivacy.getRegion();

            let message = 'Current Cookie Preferences:\n\n';
            message += `Analytics: ${currentConsent.analytics || 'Not set'}\n`;
            message += `Marketing: ${currentConsent.marketing || 'Not set'}\n`;
            message += `Preferences: ${currentConsent.preferences || 'Not set'}\n`;
            message += `Sale of Data: ${currentConsent.sale_of_data || 'Not set'}\n`;
            message += `\nRegion: ${region || 'Unknown'}\n\n`;
            message += 'Would you like to reset your preferences?';

            if (confirm(message)) {
              console.log('User wants to reset preferences');

              // Reset consent (this will likely trigger the banner to show)
              window.Shopify.customerPrivacy.setTrackingConsent({
                analytics: false,
                marketing: false,
                preferences: false
              }, () => {
                console.log('Consent reset, banner should appear');
                // Check if cookie bar appeared after reset
                setTimeout(() => {
                  const newCookieBar = document.querySelector('cookie-bar');
                  if (newCookieBar) {
                    newCookieBar.open = true;
                  }
                }, 500);
              });
            }
          }
        });
      } else {
        console.log('Link does not end with #manage-cookies');
      }
    } else {
      console.log('No link element found in click target');
    }
  });
});

// Dynamic Delivery Date Calculator
(function() {
  function calculateDeliveryMessage() {
    var translations = window.deliveryTranslations || {};
    
    // Check if custom available text is enabled
    if (translations.customAvailableEnabled && translations.customAvailableText) {
      return translations.customAvailableText;
    }
    
    var dayOfWeek, hours;
    
    // Check if test mode is enabled via section settings
    if (window.deliveryTestSettings && window.deliveryTestSettings.enabled) {
      dayOfWeek = parseInt(window.deliveryTestSettings.dayOfWeek);
      hours = parseInt(window.deliveryTestSettings.hour);
    } else {
      // Use store timezone (Europe/Zurich - Swiss time)
      var now = new Date();
      var storeTime = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Zurich' }));
      dayOfWeek = storeTime.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
      hours = storeTime.getHours();
    }
    
    // Get translations from window object
    translations = window.deliveryTranslations || {
      tomorrow: 'Morgen geliefert',
      dayAfterTomorrow: 'Übermorgen geliefert',
      monday: 'Lieferung am Montag',
      tuesday: 'Lieferung am Dienstag'
    };
    
    // Monday to Thursday (1-4)
    if (dayOfWeek >= 1 && dayOfWeek <= 4) {
      if (hours < 13) {
        return translations.tomorrow;
      } else {
        return translations.dayAfterTomorrow;
      }
    }
    // Friday (5)
    else if (dayOfWeek === 5) {
      if (hours < 13) {
        return translations.monday;
      } else {
        return translations.tuesday;
      }
    }
    // Saturday (6) or Sunday (0)
    else {
      return translations.tuesday;
    }
  }
  
  function updateDeliveryDates() {
    var deliveryElements = document.querySelectorAll('.dynamic-delivery-date');
    var message = calculateDeliveryMessage();
    
    deliveryElements.forEach(function(element) {
      element.textContent = message;
    });
  }
  
  function initDeliveryDateCalculator() {
    // Update immediately on page load
    updateDeliveryDates();
    
    // Update every minute to handle time changes
    setInterval(updateDeliveryDates, 60000);
    
    // Update when variant changes
    document.addEventListener('variant:change', function() {
      setTimeout(updateDeliveryDates, 100);
    });
    
    // Watch for dynamically added delivery date elements (quick buy, AJAX content)
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length) {
          // Check if any added nodes contain delivery date elements
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              if (node.classList && node.classList.contains('dynamic-delivery-date')) {
                updateDeliveryDates();
              } else if (node.querySelector && node.querySelector('.dynamic-delivery-date')) {
                updateDeliveryDates();
              }
            }
          });
        }
      });
    });
    
    // Start observing the document for added nodes
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDeliveryDateCalculator);
  } else {
    initDeliveryDateCalculator();
  }
})();

document.addEventListener('DOMContentLoaded', async function () {

  const sections = document.querySelectorAll('.repair-spare-part[data-product-handle]');

  for (const section of sections) {

    const handle = section.dataset.productHandle;
    const intro = section.dataset.intro || '';

    if (!handle) continue;

    try {

      const response = await fetch(`/products/${handle}.js`);
      const product = await response.json();

      const image = product.featured_image;
      const title = product.title;
      const url = `/products/${product.handle}`;

      section.innerHTML = `
        <h2>Passendes Ersatzteil</h2>
        ${intro ? `<p class="repair-spare-part__intro">${intro}</p>` : ''}

        <a href="${url}" class="repair-spare-part__card" target="_blank">

          <div class="repair-spare-part__image-wrap">
            <img src="${image}" alt="${title}">
          </div>

          <div class="repair-spare-part__content">
            <span class="repair-spare-part__label">Original Ersatzteil</span>
            <h3>${title}</h3>
            <span class="repair-spare-part__button">
              Zum Ersatzteil
            </span>
          </div>

        </a>
      `;

    } catch (error) {
      console.error("Ersatzteil konnte nicht geladen werden", error);
    }

  }

});

// Listen for Weglot language changes and re-translate dynamic content
document.addEventListener('DOMContentLoaded', function() {
  // Wait for Weglot to initialize
  var weglotCheckInterval = setInterval(function() {
    if (typeof Weglot !== 'undefined' && Weglot.initialized) {
      clearInterval(weglotCheckInterval);
      
      // Store original language
      var currentLang = Weglot.getCurrentLang();
      
      // Force translation on initial load if not in original language
      // Original language is 'de' (German)
      if (currentLang && currentLang !== 'de') {
        // Multiple translation attempts to catch all dynamic content
        var translationAttempts = [300, 700, 1200];
        translationAttempts.forEach(function(delay) {
          setTimeout(function() {
            try {
              Weglot.switchTo(currentLang);
            } catch(e) {
              console.warn('Weglot translation attempt failed:', e);
            }
          }, delay);
        });
      }
      
      // Use MutationObserver to detect when Weglot changes language
      // This observes changes to the html lang attribute which Weglot modifies
      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'lang') {
            var newLang = document.documentElement.getAttribute('lang');
            if (newLang !== currentLang) {
              var oldLang = currentLang;
              currentLang = newLang;
              
              // Force re-translation of dynamic content when language changes
              // Multiple attempts to catch all content
              var languageChangeAttempts = [200, 500, 900];
              languageChangeAttempts.forEach(function(delay) {
                setTimeout(function() {
                  try {
                    Weglot.switchTo(currentLang);
                  } catch(e) {
                    console.warn('Language change translation failed:', e);
                  }
                }, delay);
              });
            }
          }
        });
      });
      
      // Observe the html element for lang attribute changes
      observer.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['lang']
      });
    }
  }, 100);
});

// Additional check on window load to ensure all dynamic content is translated
window.addEventListener('load', function() {
  if (typeof Weglot !== 'undefined' && Weglot.initialized) {
    var currentLang = Weglot.getCurrentLang();
    // If we're viewing a translated version, force re-translation to catch any missed content
    // Original language is 'de' (German)
    if (currentLang && currentLang !== 'de') {
      // Multiple retries after page load to catch late-loading content
      var loadTranslationAttempts = [500, 1000, 1500];
      loadTranslationAttempts.forEach(function(delay) {
        setTimeout(function() {
          try {
            Weglot.switchTo(currentLang);
          } catch(e) {
            console.warn('Window load Weglot translation failed:', e);
          }
        }, delay);
      });
    }
  }
});